/* B9 (Donny 14 okt): add-to-cart-pop-up 315535 krijgt de uitklap 'How it works'; in de pop-up en in Complete Your Rotation (309892/309895) kun je per kaart door de productfoto's bladeren; bij riemen loopt de kleur in het keuzevak mee. */
(function () {
  var BLOCKS = '[data-rebuy-id="315535"] .rebuy-product-block,[data-rebuy-id="309892"] .rebuy-product-block,[data-rebuy-id="309895"] .rebuy-product-block';
  var cache = {};
  function getProd(h) {
    if (!cache[h]) cache[h] = fetch('/products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return cache[h];
  }
  function key(u) { return String(u || '').split('?')[0].replace(/^https?:/, '').replace(/_\d+x\d*(?=\.[a-z]+$)/i, ''); }
  function sized(u) { u = String(u || ''); if (u.indexOf('//') === 0) u = 'https:' + u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=500'; }
  /* Riemen (meerdere kleuren): 1 foto per kleur, gekoppeld aan het keuzevak. Doorbladeren zet de kleur in het keuzevak (maat blijft), een andere keuze in het keuzevak schuift naar die foto (Donny 14 okt). */
  function colorSlides(p) {
    var ci = -1; (p.options || []).forEach(function (o, i) { var n = (o && o.name) || o; if (/colou?r/i.test(n)) ci = i; });
    if (ci < 0) return null;
    var out = [], seen = {};
    (p.variants || []).forEach(function (v) {
      var c = v.options[ci], img = v.featured_image && v.featured_image.src;
      if (seen[c] || !img) return; seen[c] = 1; out.push({ c: c, src: img });
    });
    return out.length > 1 ? { ci: ci, slides: out } : null;
  }
  function gallery(b) {
    if (b.getAttribute('data-b9g')) return;
    var a = b.querySelector('.rebuy-product-media a'), img = a && a.querySelector('img');
    if (!img) return;
    var m = (a.getAttribute('href') || '').match(/\/products\/([^?#\/]+)/); if (!m) return;
    b.setAttribute('data-b9g', '1');
    var h = m[1]; try { h = decodeURIComponent(h); } catch (e) {}
    getProd(h).then(function (p) {
      if (!p) return;
      var cs = colorSlides(p), urls;
      if (cs) urls = cs.slides.map(function (s) { return sized(s.src); });
      else {
        var first = img.currentSrc || img.src, seen = {}; urls = [first]; seen[key(first)] = 1;
        (p.images || []).forEach(function (u) { var k = key(u); if (!seen[k] && urls.length < 8) { seen[k] = 1; urls.push(sized(u)); } });
      }
      if (urls.length < 2 || a.querySelector('.b9-g')) return;
      var g = document.createElement('div'); g.className = 'b9-g';
      g.innerHTML = '<div class="b9-g__t">' + urls.map(function (u, i) { return '<img src="' + u + '" alt="" draggable="false" loading="' + (i ? 'lazy' : 'eager') + '">'; }).join('') + '</div>'
        + '<button type="button" class="b9-g__b b9-g__b--p" aria-label="Previous image"></button><button type="button" class="b9-g__b b9-g__b--n" aria-label="Next image"></button>'
        + '<div class="b9-g__d">' + urls.map(function (u, i) { return '<i' + (i ? '' : ' class="on"') + '></i>'; }).join('') + '</div>';
      a.classList.add('b9-has-g'); a.appendChild(g);
      var t = g.querySelector('.b9-g__t'), dots = g.querySelectorAll('.b9-g__d i'), n = urls.length, quiet = false, st;
      function idx() { return Math.round(t.scrollLeft / Math.max(1, t.clientWidth)); }
      function sel() { return b.querySelector('select.rebuy-select'); }
      function varOf(id) { id = String(id); return (p.variants || []).filter(function (v) { return String(v.id) === id; })[0]; }
      /* swipen in de foto's mag de carrousel van Rebuy niet meeslepen */
      ['mousedown', 'touchstart', 'pointerdown'].forEach(function (ev) { g.addEventListener(ev, function (e) { e.stopPropagation(); }, { passive: true }); });
      function toColor(smooth) {
        var s = sel(), v = s && varOf(s.value); if (!cs || !v) return;
        var i = -1; cs.slides.forEach(function (x, j) { if (x.c === v.options[cs.ci]) i = j; });
        if (i < 0 || i === idx()) return;
        quiet = true; t.scrollTo({ left: i * t.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
        setTimeout(function () { quiet = false; }, smooth ? 600 : 50);
      }
      function fromColor() {
        var s = sel(), cur = s && varOf(s.value); if (!cs || !cur) return;
        var c = cs.slides[idx()] && cs.slides[idx()].c; if (!c || cur.options[cs.ci] === c) return;
        var ids = [].map.call(s.options, function (o) { return o.value; });
        var cand = (p.variants || []).filter(function (v) { return v.options[cs.ci] === c && ids.indexOf(String(v.id)) > -1; });
        var same = cand.filter(function (v) { return v.options.every(function (o, k) { return k === cs.ci || o === cur.options[k]; }); })[0];
        var pick = same || cand.filter(function (v) { return v.available; })[0] || cand[0]; if (!pick) return;
        s.value = String(pick.id); s.dispatchEvent(new Event('change', { bubbles: true })); s.dispatchEvent(new Event('input', { bubbles: true }));
      }
      /* Donny 14 okt: variant direct laten meeschuiven zodra de foto voor de helft in beeld is (niet pas na het stoppen) */
      var last = idx();
      t.addEventListener('scroll', function () {
        var i = idx(); if (i === last) return; last = i;
        [].forEach.call(dots, function (d, j) { d.classList.toggle('on', j === i); });
        if (!quiet) fromColor();
      }, { passive: true });
      if (cs) { b.addEventListener('change', function (e) { if (e.target && e.target.matches && e.target.matches('select.rebuy-select')) toColor(true); }); toColor(false); }
      function go(dir) {
        var i = idx() + dir;
        if (i < 0) i = n - 1; if (i > n - 1) i = 0;
        t.scrollTo({ left: i * t.clientWidth, behavior: 'smooth' });
      }
      g.querySelector('.b9-g__b--p').addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(-1); });
      g.querySelector('.b9-g__b--n').addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(1); });
    });
  }
  var HOW = '<summary>How it works</summary><ul>'
    + '<li>Add <b>all 3 items</b> to your cart. The free one is not added for you.</li>'
    + '<li><b>Mix &amp; match</b> belts and golf polos in any design, color and size.</li>'
    + '<li>In your cart, <b>1 of the 3 will become free</b> automatically. No code needed.</li>'
    + '<li>Buying more? <b>6 items, 2 free.</b></li></ul>';
  function how() {
    var c = document.querySelector('[data-rebuy-id="315535"] .rebuy-widget-content');
    if (c && !c.querySelector('.b9-pop-how')) {
      var at = c.querySelector('.description') || c.querySelector('.primary-title');
      if (at) { var d = document.createElement('details'); d.className = 'b9-pop-how'; d.innerHTML = HOW; at.parentNode.insertBefore(d, at.nextSibling); }
    }
    /* B2G1-widget op de PDP (309892/309895): zelfde uitklap onder de titel (Donny 14 okt) */
    [].forEach.call(document.querySelectorAll('[data-rebuy-id="309892"] .rebuy-widget, [data-rebuy-id="309895"] .rebuy-widget'), function (w) {
      var t = w.querySelector('.primary-title'); if (!t || w.querySelector('.b9-pop-how')) return;
      var d = document.createElement('details'); d.className = 'b9-pop-how b9-pop-how--pdp'; d.innerHTML = HOW; t.parentNode.insertBefore(d, t.nextSibling);
    });
  }
  /* Foto's swipen op mobiel mag de Rebuy-carrousel niet meenemen (Donny 14 okt). Splide luistert in de capture-fase op de track,
     dus we stoppen het begin van de veeg al op window (capture) zodra die in de foto-galerij begint. Native scrollen van de galerij blijft werken. */
  ['touchstart', 'pointerdown', 'mousedown'].forEach(function (ev) {
    window.addEventListener(ev, function (e) { if (e.target && e.target.closest && e.target.closest('.b9-g')) e.stopPropagation(); }, { capture: true, passive: true });
  });
  /* Pop-up eerst, daarna pas de cart (Donny 14 okt). Bij Add to cart op de PDP tonen we de pop-up zodra het product in de cart zit, met de producten die al geladen zijn
     (Rebuy deed dat pas ~3 s later, na de cart). De cart van Rebuy wacht tot de pop-up dicht is; komt de pop-up niet binnen 4,5 s, dan opent de cart gewoon. */
  var hold = 0, pending = null, blockUntil = 0, popW = null, hooked = false;
  function pw() {
    if (popW) return popW;
    var ws = (window.Rebuy && Rebuy.widgets) || {};
    for (var k in ws) if (ws[k] && String(ws[k].id) === '315535' && ws[k].data) { popW = ws[k]; break; }
    return popW;
  }
  function popOpen() { var w = pw(); return !!(w && w.data && w.data.visible); }
  function release() { if (!pending) return; var p = pending; pending = null; p[0].apply(p[1], p[2]); }
  function hook() {
    if (hooked) return;
    var sc = window.Rebuy && Rebuy.SmartCart, w = pw();
    if (!sc || typeof sc.show !== 'function' || !w) return;
    var d = Object.getOwnPropertyDescriptor(w.data, 'visible');
    if (!d || !d.get || !d.set || !d.configurable) return;
    hooked = true;
    var os = sc.show;
    sc.show = function () {
      if (popOpen() || Date.now() - hold < 4500) { pending = [os, this, arguments]; return; }
      return os.apply(this, arguments);
    };
    Object.defineProperty(w.data, 'visible', {
      configurable: true, enumerable: true, get: d.get,
      set: function (v) {
        if (v && Date.now() < blockUntil) return; /* Rebuy wil de pop-up na het ophalen nog eens openen terwijl de klant hem al sloot */
        var was = d.get.call(this); d.set.call(this, v);
        if (was && !v) { blockUntil = Date.now() - hold < 6000 ? Date.now() + 5000 : 0; hold = 0; setTimeout(release, 150); }
      }
    });
  }
  function onAtc(e) {
    var f = e.target && e.target.closest && e.target.closest('form[action*="/cart/add"]');
    if (!f || f.closest('.rebuy-widget, #rebuy-cart')) return;
    if (e.type === 'click' && !e.target.closest('button[type="submit"], button[name="add"], input[type="submit"]')) return;
    var btn = f.querySelector('button[name="add"], button[type="submit"]'); if (btn && btn.disabled) return;
    hook(); var w = pw(); if (!hooked || !w || !w.data.products || !w.data.products.length) return;
    if (Date.now() - hold < 1000) return;
    hold = Date.now(); blockUntil = 0; waitAdd = true;
    setTimeout(function () { if (!popOpen()) { waitAdd = false; hold = 0; release(); } }, 4600);
  }
  /* Iets later tonen (Donny 14 okt): pas als het product echt in de cart zit (Rebuy-event rebuy:cart.add) plus 400 ms,
     zodat de klant ziet dat zijn product is toegevoegd. Mislukt het toevoegen, dan komt er geen pop-up. */
  var waitAdd = false;
  document.addEventListener('rebuy:cart.add', function () {
    if (!waitAdd || Date.now() - hold > 4000) return; waitAdd = false;
    setTimeout(function () { var w = pw(); if (w && !w.data.visible && Date.now() >= blockUntil) w.data.visible = true; }, 400);
  });
  document.addEventListener('click', onAtc, true);
  document.addEventListener('submit', onAtc, true);
  /* Prijzen in de Rebuy-kaarten gelijk aan Shopify (Donny 14 okt): Rebuy toont na het inladen van de BF-prijslijsten soms nog oude marktprijzen uit zijn cache.
     We nemen prijs en compare-at van de gekozen variant uit /products/<handle>.js (al in de valuta en market van de bezoeker). */
  var PB = '.rebuy-widget .rebuy-product-block';
  function money(cents, sample) {
    var a = (cents / 100).toFixed(2), comma = /\d,\d{2}(?!\d)/.test(sample || '');
    if (comma) a = a.replace('.', ',');
    return String(sample || '').replace(/\d[\d.,]*/, a);
  }
  function setTxt(el, cents) {
    if (!el || !(cents > 0)) return;
    var t = el.querySelector('span:not(.sr-only)') || el, cur = t.textContent, nv = money(cents, cur);
    if (nv && nv !== cur) t.textContent = nv;
  }
  function fixPrice(b) {
    var a = b.querySelector('a[href*="/products/"]'); if (!a) return;
    var m = (a.getAttribute('href') || '').match(/\/products\/([^?#\/]+)/); if (!m) return;
    var h = m[1]; try { h = decodeURIComponent(h); } catch (e) {}
    getProd(h).then(function (p) {
      if (!p || !p.variants) return;
      var s = b.querySelector('select.rebuy-select'), vid = s ? s.value : ((a.getAttribute('href') || '').match(/variant=(\d+)/) || [])[1];
      var v = p.variants.filter(function (x) { return String(x.id) === String(vid); })[0] || p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
      if (!v) return;
      setTxt(b.querySelector('.rebuy-money.sale') || b.querySelector('.rebuy-product-price .rebuy-money'), v.price);
      if (v.compare_at_price > v.price) setTxt(b.querySelector('.rebuy-money.compare-at'), v.compare_at_price);
    });
  }
  document.addEventListener('change', function (e) { var b = e.target && e.target.closest && e.target.closest(PB); if (b) setTimeout(function () { fixPrice(b); }, 60); }, true);
  function run() { how(); hook(); [].forEach.call(document.querySelectorAll(BLOCKS), gallery); [].forEach.call(document.querySelectorAll(PB), fixPrice); }
  var tm; new MutationObserver(function () { clearTimeout(tm); tm = setTimeout(run, 120); }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

/* Productkaarten (Donny 14 okt): prijzen per rij op één lijn. Titels in dezelfde rij krijgen dezelfde hoogte (2 of 3 regels),
   zodat de prijs overal direct onder de titel op dezelfde hoogte staat. Kleurbolletjes staan onder de prijs; de ruimte valt boven de knop. */
(function () {
  var SEL = 'product-card.product-card .product-card-info > .product-card-title', tm;
  function eq() {
    var ts = [].slice.call(document.querySelectorAll(SEL)).filter(function (t) { return t.offsetParent; });
    ts.forEach(function (t) { t.style.transition = 'none'; t.style.minHeight = ''; });
    var rows = {};
    ts.forEach(function (t) {
      var card = t.closest('product-card'), k = (card.parentElement ? card.parentElement.parentElement && card.parentElement.parentElement.className : '') + '|' + Math.round(card.getBoundingClientRect().top + window.scrollY);
      (rows[k] = rows[k] || []).push(t);
    });
    Object.keys(rows).forEach(function (k) {
      var r = rows[k]; if (r.length < 2) return;
      var h = Math.max.apply(null, r.map(function (t) { return t.getBoundingClientRect().height; }));
      r.forEach(function (t) { t.style.minHeight = Math.ceil(h) + 'px'; });
    });
  }
  function later() { clearTimeout(tm); tm = setTimeout(eq, 120); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', later); else later();
  window.addEventListener('load', later);
  window.addEventListener('resize', later);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(later);
  if (window.MutationObserver) new MutationObserver(function (m) {
    for (var i = 0; i < m.length; i++) for (var j = 0; j < m[i].addedNodes.length; j++) { var n = m[i].addedNodes[j]; if (n.nodeType === 1 && (n.matches('product-card') || n.querySelector && n.querySelector('product-card'))) { later(); return; } }
  }).observe(document.body, { childList: true, subtree: true });
})();

/* Widget-foto's (Donny 14 okt): per veeg 1 foto verder, niet meerdere tegelijk */
(function () { var st = document.createElement('style'); st.textContent = '.b9-g__t img{scroll-snap-stop:always}'; (document.head || document.documentElement).appendChild(st); })();
